<template>
  <div id="taskAdd">
      <v-layout wrap row mb-1>
      <v-flex md6 pb-4 style="min-height:70px;">
        <v-btn fab left to="/tasks" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" to="/tasks">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="taskAdd">
      <v-container>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Task name" :rules="rules" v-model.trim="TaskModel.name" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Task identifier" :rules="rules" v-model.trim="TaskModel.identifier" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-textarea label="Description" rows="3" :rules="descriptionRules" v-model.trim="TaskModel.description" class="required pr-4 pl-4" @input="changedData" required></v-textarea>
          </v-flex>
        </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-select @input="changedData" small-chips deletable-chips multiple :rules="membershipRules" :items="membershipList" v-model="TaskModel.membership" label="Membership" class="required pr-4 pl-4" required></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-text-field label="Relative UI action link" :rules="actionLinkRules" v-model.trim="TaskModel.action_link" class="pr-4 pl-4" hint="Example: /path/to/page" persistent-hint @input="changedData"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-select label="Whether to force user to complete?" :items="[{ text: 'Yes', value: true }, { text: 'No', value: false }]" v-model.trim="TaskModel.force_complete" class="pr-4 pl-4" @input="changedData"></v-select>
        </v-flex>
      </v-layout>
      <v-layout v-for="(link, index) in links" :key="index">
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Link" :rules="urlRules" hint="Ex: https://example.com, http://example.com" v-model="link.url" name="links[][url]" class="pr-4 pl-4" @input="changedData"></v-text-field>
          </v-flex>
          <v-btn icon class="mt-3 mr-3 mb-3 ml-0" @click="removeLink(index)">
            <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
          </v-btn>
      </v-layout>
      <v-btn type="button" v-on:click="addNewLink" class="btn-link pf-btn-fab">Add link</v-btn>

      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" to="/tasks">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
/* global session store */
import { create, getCollection, validateUrl } from '../../helpers/helpers';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'taskAdd',
  data: () => ({
    selectedData: false,
    TaskModel: {
      name: '',
      description: '',
      identifier: 0,
      membership: '',
      sort_no: 0,
      action_link: '',
      force_complete: false
    },
    membershipList: [
      'Network',
      'Featured',
      'Preferred'
    ],
    membershipRules: [
      v => v.length > 0 || 'membership is required'
    ],
    actionLinkRules: [
      v => !v || v.trim() === '' || /^\/[a-zA-Z0-9_\-\/]+$/.test(v) || 'Please enter valid relative URL'
    ],
    link: {
      url: ''
    },
    links: [{ 'url': '' }],
    rules: [
      v => !!v || 'Please fill this field'
    ],
    descriptionRules: [
      v => !!v || 'Task description is required'
    ],
    urlRules: [
      v => v === '' || validateUrl(v) || 'Please enter valid URL'
    ]
  }),
  computed: {
    ...mapGetters(['Task'])
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.getTasks();
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    async getTasks () {
      if (!this.Task.length) {
        let entity = `Task`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setTask', data);
          }
        }
      }
    },
    async save () {
      if (this.$refs.taskAdd.validate()) {
        let linkArray = [];
        for (let i = 0; i < this.links.length; i++) { 
          linkArray.push(this.links[i].url);
        }
        if (linkArray) {
          this.TaskModel.links = linkArray;
        }
        if (this.TaskModel.identifier && this.TaskModel.identifier !== '') {
          this.TaskModel.identifier = parseInt(this.TaskModel.identifier, 10);
        }
        this.selectedData = false;
        this.TaskModel.sort_no = this.Task.length + 1;
        let { error, data, status } = await create('Task', this.TaskModel);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.Task.push(data);
          swal.fire({
            type: 'success',
            title: 'Task added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/tasks' });
            }
          });
        }
      }
    },
    changedData () {
      this.selectedData = true;
      // let length = 0;
      // if (this.membershipList.indexOf(value) !== -1) {
      //   let currentMembership = this.Task.filter(task => value === task.membership);
      //   if (currentMembership.length) {
      //     length = Math.max.apply(null, currentMembership.map(item => item.sort_no));
      //   }
      //   this.TaskModel.sort_no = length + 1;
      // }
    },
    addNewLink: function () {
      this.links.push(Vue.util.extend({}, this.links));
    },
    removeLink: function (index) {
      Vue.delete(this.links, index);
      this.selectedData = true;
    },
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }

  #taskAdd >>> .v-textarea textarea {
    margin-top: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Tasks/add.vue